import { SVGProps } from 'react';

const Learning = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M16.5 4.044a9.75 9.75 0 0 1 4.875 1.307.75.75 0 0 1 .375.65v13a.75.75 0 0 1-1.125.649 8.25 8.25 0 0 0-8.25 0 .75.75 0 0 1-.75 0 8.25 8.25 0 0 0-8.25 0A.75.75 0 0 1 2.25 19V6l.007-.1a.75.75 0 0 1 .368-.55A9.75 9.75 0 0 1 12 5.147a9.749 9.749 0 0 1 4.5-1.102Zm-9 1.5a8.25 8.25 0 0 0-3.75.903v11.347a9.75 9.75 0 0 1 7.5 0V6.447a8.25 8.25 0 0 0-3.75-.903Zm9 0a8.25 8.25 0 0 0-3.75.903v11.347a9.75 9.75 0 0 1 7.5 0V6.447a8.25 8.25 0 0 0-3.75-.903Z"
    />
  </svg>
);

export default Learning;
